import { render, staticRenderFns } from "./RADIOBUTTON.vue?vue&type=template&id=026f9a95&scoped=true&"
import script from "./RADIOBUTTON.vue?vue&type=script&lang=js&"
export * from "./RADIOBUTTON.vue?vue&type=script&lang=js&"
import style0 from "./RADIOBUTTON.vue?vue&type=style&index=0&id=026f9a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f9a95",
  null
  
)

export default component.exports